import axios from 'axios';
import store from '../store';
import { isNullOrEmpty } from './utils';

axios.defaults.withCredentials = true;

const handleAuthCheck = () => {
  let authCheckTime = store.state.auth.authCheckTime;
  let currentDate = new Date();

  if(authCheckTime !== null && currentDate > authCheckTime) {
    return Promise.resolve(false);
  }

  let username = store.getters.adminUser.username;

  if(username === null) {
    return Promise.resolve(false);
  }

  let getData = false;
  const assignmentsCheckTime = !isNullOrEmpty(store.state.auth.assignmentsCheckTime) ? store.state.auth.assignmentsCheckTime : null;
  if (assignmentsCheckTime) {
    const checkIntervalMs = store.state.auth.authCheckInterval * 60000;
    const intervalMs = checkIntervalMs * 0.5;
    const elapsedMs = Math.abs(currentDate - assignmentsCheckTime);

    if (elapsedMs > intervalMs) {
      getData = true;
    }
  }
  let url = `${process.env.VUE_APP_API_URL}admin/users/${username}/${getData}`;

  return axios
    .get(url)
    .then(response => {
      let result = false;

      if (Array.isArray(response.data.user.roles)) {
        store.commit('addAuthenticatedUser', response.data);
        result = true;
      }

      return result;
    });
}

export const isAuthorized = (role) => {
  if(store.state.auth.adminOverride) {
    return Promise.resolve(true);
  }

  return handleAuthCheck()
    .then((result) => {
      if(result === false) {
        return false;
      }

      return store.getters.hasRole(role);
    })
}

export const getAdminUsers = () => {
  let url = `${process.env.VUE_APP_API_URL}admin/users`;

  return axios
    .get(url);
}

export const getAdminManagerUsers = () => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/manager`;

  return axios
    .get(url);
}

export const getAdminUserUsers = () => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/user`;

  return axios
    .get(url);
}

export const getAdminAssignableUsers = () => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/assignable`;

  return axios
    .get(url);
}

export const getSurveyAdminUsers = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/surveyusers`;
  if (payload) {
    if (payload.surveyUrlId) {
      const orgSurvey = store.getters.getOrgSurveyByUrlId(payload.surveyUrlId);
      url += `/${orgSurvey.surveyId}/${orgSurvey.orgSurveyId}`;
    }
    else if (payload.surveyId) {
      url += "/" + payload.surveyId;
    }
  }

  return axios
    .get(url);
}

export const signoutUser = () => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/signout`;

  store.commit('removeAuthenticatedUser');

  return axios
    .get(url);
}

export const confirmEmail = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/email`;

  return axios
    .post(url, payload)
}

export const finalizeConfirmation = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/emailConfirmed`;

  return axios
    .post(url, payload);
}

export const resetRequest = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/reset`;

  return axios
    .post(url, payload);
}

export const resetConfirmed = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/resetConfirmed`;

  return axios
    .post(url, payload);
}

export const changePassword = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/password`;

  return axios
    .post(url, payload)
}

export const addAdminUser = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users`;

  return axios
    .post(url, payload)
}

export const getRoles = () => {
  let url = `${process.env.VUE_APP_API_URL}admin/roles`;

  return axios
    .get(url);
}

export const getRoleLevels = async () => {
  let url = `${process.env.VUE_APP_API_URL}admin/rolelevels`;

  const response = await axios.get(url);
  store.commit('updateConstants', { roleLevels: response.data });
}


export const getRolesAsync = async () => {
  let url = `${process.env.VUE_APP_API_URL}admin/roles`;

  let response = await axios.get(url);
  return response.data;
}

export const addRole = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/roles/add`;
  const usr = store.getters.adminUser;
  payload.AdminUser = { UserName: usr.username, Roles: usr.roles };

  return axios
    .post(url, payload);
}

export const deleteRole = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/roles/delete`;
  const usr = store.getters.adminUser;
  payload.AdminUser = { UserName: usr.username, Roles: usr.roles };

  return axios
    .post(url, payload);
}

export const deleteAdminUser = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/delete/${payload.username}`;
  let request = { AuthUser: store.getters.adminUser };
  if (payload.hasOwnProperty("refreshData")) {
    request.RefreshData = payload.refreshData;
  }

  return axios
    .post(url, request);
}

export const addSurveyAdminUser = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/surveyusers/add/${payload.username}`;

  return axios
    .post(url, payload.surveyUser)
}

export const deleteSurveyAdminUser = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/surveyusers/delete/${payload.id}`;
  // let request = { AuthUser: store.getters.adminUser };
  let request = { RefreshData: false };
  if (payload.hasOwnProperty("refreshData")) {
    request.RefreshData = payload.refreshData;
  }

  return axios.post(url, request);
}

export const getUserSurveys = (username) => {
  username = username || store.getters.adminUser.username;
  let url = `${process.env.VUE_APP_API_URL}admin/users/${username}/surveys`;

  return axios.get(url);
}

export const getUserNumberOfSurveys = async (username) => {
  username = username || store.getters.adminUser.username;
  let url = `${process.env.VUE_APP_API_URL}admin/users/${username}/numberSurveys`;

  const result = await axios.get(url);
  return result.data;
}

export const getUserNumberOfSurveyInstances = async (username) => {
  username = username || store.getters.adminUser.username;
  let url = `${process.env.VUE_APP_API_URL}admin/users/${username}/numberSurveyInstances`;

  const result = await axios.get(url);
  return result.data;
}

export const getReportLinks = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/links`;
  if (payload) {
    if (payload.surveyUrlId) {
      const orgSurvey = store.getters.getOrgSurveyByUrlId(payload.surveyUrlId);
      url = `${process.env.VUE_APP_API_URL}admin/links/${orgSurvey.surveyId}/${orgSurvey.surveyUrlId}`;
    }
    else if (payload.surveyId) {
      url += "/" + payload.surveyId;
    }
  }

  return axios.get(url);
}

export const addReportLink = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/links/add`;

  return axios
    .post(url, payload)
}

export const deleteReportLink = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/links/delete/${payload.id}`;

  return axios
    .post(url);
}

export const getReportFiles = (payload) => {
  let username = store.getters.adminUser.username;

  if (username === null) {
    return Promise.resolve(false);
  }
  
  let isManaging = payload.isManaging || false;
  let url = `${process.env.VUE_APP_API_URL}admin/${username}/reports/${payload.hspSurveyId}/${payload.surveyUrlId}/${isManaging}`;

  return axios.get(url);
}

export const getDownloadFile = async (payload) => {
  const response = await axios.get(payload.url, { responseType: 'blob' });

  return response;
}

export const uploadReportFiles = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/reports/upload/${payload.hspSurveyId}/${payload.surveyUrlId}`;

  return axios.post(url, payload.formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export const deleteReportFiles = (payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/reports/delete/${payload.hspSurveyId}/${payload.surveyUrlId}`;

  return axios
    .post(url, payload.files);
}
